import { useLocation } from 'react-router';

import { ROUTES } from '#/config/routes';

const WORK_ORDER_TRANSFER_PATH = '/order-mgmt/transfer';

export function isWorkOrderTransferPath(pathname) {
  return String(pathname ?? '').includes(WORK_ORDER_TRANSFER_PATH);
}

/** 依目前 pathname 分流 IMS 手動轉倉／工單轉倉入口。 */
export function getStockTransferEntryRoutes(pathname) {
  if (isWorkOrderTransferPath(pathname)) {
    return {
      list: ROUTES.workOrderTransfer,
      detail: ROUTES.workOrderTransferDetail,
      edit: ROUTES.workOrderTransferEdit,
      remark: ROUTES.workOrderTransferRemark,
    };
  }

  return {
    list: ROUTES.stockTransfer,
    detail: ROUTES.stockTransferDetail,
    edit: ROUTES.stockTransferEdit,
    remark: ROUTES.stockTransferRemark,
  };
}

export function useStockTransferEntryRoutes() {
  const { pathname } = useLocation();
  return {
    ...getStockTransferEntryRoutes(pathname),
    isWorkOrderTransfer: isWorkOrderTransferPath(pathname),
  };
}
